module.exports = __webpack_public_path__ + "static/media/calendar.b5868efe.png";